// skipcq: JS-W1028
import React from 'react';
import { node, number, bool } from 'prop-types';
// Material UI
import Container from '@mui/material/Container';

const TabPanel = (props) => {
  const { children, value, index, disableGutters = false, ...other } = props;

  return (
    <Container
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      disableGutters={disableGutters}
      maxWidth={false}
      {...other}
    >
      {value === index && children}
    </Container>
  );
};

TabPanel.propTypes = {
  children: node.isRequired,
  index: number.isRequired,
  value: number.isRequired,
  disableGutters: bool,
};

export default TabPanel;
